import { ComponentProps, ForwardRefRenderFunction, ReactNode, forwardRef } from 'react';
import styled from 'styled-components';
import { InputLeftPadding } from '../../../constants/Layout';
import { Screen, Spacing } from '../../../theme';

export type FlexContainerProps = {
  children: ReactNode | ReactNode[];
  flexDirection?: 'row' | 'column';
  // Consider typing this 2
  align?: string;
  justify?: string;
  gap?: Spacing;
  breaks?: Screen;
  padding?: Spacing;
  width?: string;
  padLeft?: boolean;
  padRight?: boolean;
} & ComponentProps<'div'>;

const FlexRoot = styled.div<FlexContainerProps>`
  width: ${(p) => (p.width ? p.width : '100%')};
  display: flex;
  flex-direction: ${(p) => (p.flexDirection ? p.flexDirection : 'row')};
  align-items: ${(p) => (p.align ? p.align : `normal`)};
  justify-content: ${(p) => (p.justify ? p.justify : `normal`)};
  gap: ${(p) => (p.gap ? p.theme.spacing[p.gap] : `none`)};
  /* A table title and its table form one panel: cancel the gap between them. */
  ${(p) => p.gap && `& > [data-table-title] + table { margin-top: -${p.theme.spacing[p.gap]}; }`}
  padding: ${(p) => (p.padding ? p.theme.spacing[p.padding] : `none`)};

  ${(p) => p.padLeft && `padding-left: ${InputLeftPadding}`};
  ${(p) => p.padRight && `padding-right: ${InputLeftPadding}`};

  ${(p) => {
    if (p.breaks) {
      const screenSize = p.theme.screen[p.breaks];
      const cssRule = `  @media (max-width: ${screenSize}) {
        flex-direction: column;
      };`;
      return cssRule;
    }
  }}
`;

const FlexContainer: ForwardRefRenderFunction<HTMLDivElement, FlexContainerProps> = ({ children, ...props }, ref) => {
  return (
    <FlexRoot {...props} ref={ref}>
      {children}
    </FlexRoot>
  );
};

export default forwardRef(FlexContainer);
